import { memo } from 'react';

import { OrderSpot } from '@/App/tiles/orders/components/OrderSpot.tsx';
import { useFixingTileId } from '@/App/tiles/orders/FixingOrder/FixingContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectSpotFixingData } from '@/store/orders/fixing/selectors.ts';

export const ConnectedFixingOrderSpot = memo(() => {
  const tileId = useFixingTileId();
  const spotDate = useAppSelector((state) => selectSpotFixingData(state, tileId));

  return <OrderSpot spotDate={spotDate} />;
});
